export const KYB_OWNER = {
  bo_user_24c73f7ccb9a46aaa4b4a8191cd5a50a: "Anthony Yeoh",
  bo_user_f0b7ac73c2af4fdca4e2cecc2a04d8c2: "Gurpreet Gill",
  bo_user_f32fbcb0d1704a14bb7eadbb7b8b10c9: "Deepak Moger",
  bo_user_17cbf52503f14c71bb9e5bccfefd06b5: "Revathi M",
  bo_user_2762cb0918c4439da4af3b80c8e66f27: "Ishwar Olekar",
  bo_user_b002bea6ca0f442b97aadb6b9b9648b6: "Milan Kumar",
};

export const DATE_CONVERSION_FORMAT = "EEE, dd MMM yyyy, ppp";
export const DATETIME_TO_DATE_FORMAT = "yyyy-MM-dd";
export const recurring_fees_date_limit = new Date(2037, 11, 31);
export const DATE_FORMAT = "dd MMM yy";

export const column_setting_keys = {
  ORGANIZATION_COLUMNS: "organization_columns",
  KYB_COLUMNS: "kyb_columns",
  PAYIN_COLUMNS: "payin_columns",
  VIRTUAL_ACCOUNT_COLUMNS: "virtual_account_columns",
  CHECKOUT_COLUMNS: "checkout_columns",
  BO_ACCOUNT_COLUMNS: "bo_account_columns",
  CUSTOMER_COLUMNS: "customer_columns",
  WALLET_COLUMNS: "wallet_columns",
  TRANSACTION_COLUMNS: "transaction_columns",
  STABLES_TRANSACTION_COLUMNS: "stables_transaction_columns",
  PROVIDER_COLUMNS: "provider_columns",
  SETTLEMENT_COLUMNS: "settlement_columns",
  SETTLEMENT_PAYOUT_COLUMNS: "settlement_payout_columns",
  SCHEDULER_REPOSITORY_COLUMNS: "scheduler_repository_columns",
  PAYIN_METHOD_CONFIG_COLUMNS: "payin_method_config_columns",
  INVOICING_COLUMNS: "invoicing_columns",
  PAYOUT_METHOD_COLUMNS: "payout_method_columns",
  PAYIN_METHOD_COLUMNS: "payin_method_columns",
  TRANSACTION_MONITORING_COLUMNS: "transaction_monitoring_columns",
  WFT_COLUMNS: "wft_columns",
  PAYOUT_COLUMNS: "payout_columns",
  WALLET_BALANCE_COLUMNS: "wallet_balance_columns",
  AUDIT_TRAIL_COLUMNS: "audit_trail_columns",
  BO_AUDIT_TRAIL_COLUMNS: "bo_audit_trail_columns",
  PARTNER_AUDIT_TRAIL_COLUMNS: "partner_audit_trail_columns",
  RECON_JOB_COLUMNS: "recon_job_columns",
  RECON_BATCH_COLUMNS: "recon_batch_columns",
  RECONCILIATION_ENTITY_COLUMNS: "reconciliation_entity_columns",
  ADJUSTMENT_COLUMNS: "adjustment_columns",
  FX_CONVERSION_COLUMNS: "fx_conversion_columns",
  FEES_ADJUSTMENT_COLUMNS: "fees_adjustment_columns",
  PRICING_SETUP_COLUMNS: "pricing_setup_columns",
  PARTNER_COLUMNS: "partner_columns",
  ALERT_COLUMNS: "alert_columns",
  TRANSFER_COLUMNS: "transfer_columns",
  BROADCAST_EMAIL_COLUMNS: "broadcast_email_columns",
  INVOICE_CONFIG_COLUMNS: "invoice_config_columns",
  INVEST_ACCOUNT_COLUMNS: "invest_account_columns",
  INVOICE_COLUMNS: "invoice_columns",
  SESSION_IP_LOCATION_COLUMNS: "session_ip_location_columns",
  DISPUTE_COLUMNS: "DISPUTE_COLUMNS",
  BANK_COLUMNS: "BANK_COLUMNS",
  BANK_ACCOUNTS_COLUMNS: "BANK_ACCOUNTS_COLUMNS",
  BALANCES_COLUMNS: "BALANCES_COLUMNS",
  BANK_TRANSACTIONS_COLUMNS: "BANK_TRANSACTIONS_COLUMNS",
  BANK_TRANSFER_COLUMNS: "BANK_TRANSFER_COLUMNS",
  ACTIVE_KEYS_COLUMNS: "ACTIVE_KEYS_COLUMNS",
  REFUND_COLUMNS: "REFUND_COLUMNS",
  OFFBOARDING_COLUMNS: "OFFBOARDING_COLUMNS",
  SAFEGUARDING_CONFIG_COLUMNS: "SAFEGUARDING_CONFIG_COLUMNS",
  ENTITY_CURRENCY_BALANCES_COLUMNS: "ENTITY_CURRENCY_BALANCES_COLUMNS",
};

export const CRON_VALIDATION_REGEX = /^(((\*|(\d\d?))(\/\d\d?)?)|(\d\d?\-\d\d?))(,(((\*|(\d\d?))(\/\d\d?)?)|(\d\d?\-\d\d?)))*\s(((\*|(\d\d?))(\/\d\d?)?)|(\d\d?\-\d\d?))(,(((\*|(\d\d?))(\/\d\d?)?)|(\d\d?\-\d\d?)))*\s(\?|(((\*|(\d\d?L?))(\/\d\d?)?)|(\d\d?L?\-\d\d?L?)|L|(\d\d?W))(,(((\*|(\d\d?L?))(\/\d\d?)?)|(\d\d?L?\-\d\d?L?)|L|(\d\d?W)))*)\s(((\*|(\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))(\/\d\d?)?)|((\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\-(\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)))(,(((\*|(\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))(\/\d\d?)?)|((\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\-(\d|10|11|12|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))))*\s(((\*|([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?)(\/\d\d?)?)|(([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?\-([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?)|([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?#([1-5]))(,(((\*|([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?)(\/\d\d?)?)|(([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?\-([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?)|([0-7]|MON|TUE|WED|THU|FRI|SAT|SUN)L?#([1-5])))*$/;

export const LIMIT_OFFSET = 1000000;
export const ORG_FILTER_LIMIT = 3600;

export const wallet_scope = [
  {
    value: "master",
    label: "ORGANIZATION",
  },
  {
    value: "customer",
    label: "CUSTOMER",
  },
];

export const wft_allowed_currency_list = [
  "AUD",
  "PHP",
  "THB",
  "NZD",
  "SGD",
  "GBP",
  "EUR",
  "IDR",
  "MYR",
  "VND",
  "USD",
];

export const currency_decimal = {
  AED: 2,
  AFN: 2,
  ALL: 2,
  AMD: 2,
  ANG: 2,
  AOA: 2,
  ARS: 2,
  AUD: 2,
  AWG: 2,
  AZN: 2,
  BAM: 2,
  BBD: 2,
  BDT: 2,
  BGN: 2,
  BHD: 3,
  BIF: 0,
  BMD: 2,
  BND: 2,
  BOB: 2,
  BOV: 2,
  BRL: 2,
  BSD: 2,
  BTN: 2,
  BWP: 2,
  BYR: 0,
  BZD: 2,
  CAD: 2,
  CDF: 2,
  CHE: 2,
  CHF: 2,
  CHW: 2,
  CLF: 0,
  CLP: 0,
  CNH: 2,
  CNY: 2,
  COP: 2,
  COU: 2,
  CRC: 2,
  CUC: 2,
  CUP: 2,
  CVE: 0,
  CZK: 2,
  DJF: 0,
  DKK: 2,
  DOP: 2,
  DZD: 2,
  EGP: 2,
  ERN: 2,
  ETB: 2,
  EUR: 2,
  FJD: 2,
  FKP: 2,
  GBP: 2,
  GEL: 2,
  GHS: 2,
  GIP: 2,
  GMD: 2,
  GNF: 0,
  GTQ: 2,
  GYD: 2,
  HKD: 2,
  HNL: 2,
  HRK: 2,
  HTG: 2,
  HUF: 2,
  IDR: 2,
  ILS: 2,
  INR: 2,
  IQD: 3,
  IRR: 0,
  ISK: 0,
  JMD: 2,
  JOD: 3,
  JPY: 0,
  KES: 2,
  KGS: 2,
  KHR: 2,
  KMF: 0,
  KPW: 0,
  KRW: 0,
  KWD: 3,
  KYD: 2,
  KZT: 2,
  LAK: 0,
  LBP: 0,
  LKR: 2,
  LRD: 2,
  LSL: 2,
  LTL: 2,
  LVL: 2,
  LYD: 3,
  MAD: 2,
  MDL: 2,
  MGA: 0,
  MKD: 0,
  MMK: 0,
  MNT: 2,
  MOP: 2,
  MRO: 0,
  MUR: 2,
  MVR: 2,
  MWK: 2,
  MXV: 2,
  MYR: 2,
  MZN: 2,
  NAD: 2,
  NGN: 2,
  NIO: 2,
  NOK: 2,
  NPR: 2,
  NZD: 2,
  OMR: 3,
  PAB: 2,
  PEN: 2,
  PGK: 2,
  PHP: 2,
  PKR: 2,
  PLN: 2,
  PYG: 0,
  QAR: 2,
  RON: 2,
  RSD: 2,
  RUB: 2,
  RWF: 0,
  SAR: 2,
  SBD: 2,
  SCR: 2,
  SDG: 2,
  SEK: 2,
  SGD: 2,
  SHP: 2,
  SLL: 0,
  SOS: 2,
  SRD: 2,
  SSP: 2,
  STD: 0,
  SYP: 2,
  SZL: 2,
  THB: 2,
  TJS: 2,
  TMT: 2,
  TND: 3,
  TOP: 2,
  TRY: 2,
  TTD: 2,
  TWD: 2,
  TZS: 2,
  UAH: 2,
  UGX: 2,
  USD: 2,
  USN: 2,
  USS: 2,
  UYI: 0,
  UYU: 2,
  UZS: 2,
  VEF: 2,
  VND: 0,
  VUV: 0,
  WST: 2,
  XAF: 0,
  XAG: 0,
  XAU: 0,
  XBA: 0,
  XBB: 0,
  XBC: 0,
  XBD: 0,
  XCD: 2,
  XDR: 0,
  XFU: 0,
  XOF: 0,
  XPD: 0,
  XPF: 0,
  XPT: 0,
  XTS: 0,
  XXX: 0,
  YER: 2,
  ZAR: 2,
  ZMW: 2,
};

export const all_gca_currency = {
  AED: {
    iso_name: "AED",
    full_name: "United Arab Emirates Dirham",
    type: "SECONDARY",
  },
  AUD: {
    iso_name: "AUD",
    full_name: "Australian Dollar",
    type: "PRIMARY",
  },
  BGN: {
    iso_name: "BGN",
    full_name: "Bulgarian Lev",
    type: "SECONDARY",
  },
  BHD: {
    iso_name: "BHD",
    full_name: "Bahraini Dinar",
    type: "SECONDARY",
  },
  CAD: {
    iso_name: "CAD",
    full_name: "Canadian Dollar",
    type: "PRIMARY",
  },
  CHF: {
    iso_name: "CHF",
    full_name: "Swiss Franc",
    type: "SECONDARY",
  },
  CNY: {
    iso_name: "CNY",
    full_name: "Chinese Yuan (Offshore)",
    type: "SECONDARY",
  },
  CZK: {
    iso_name: "CZK",
    full_name: "Czech Republic Koruna",
    type: "SECONDARY",
  },
  DKK: {
    iso_name: "DKK",
    full_name: "Danish Krone",
    type: "SECONDARY",
  },
  EUR: {
    iso_name: "EUR",
    full_name: "Euro",
    type: "PRIMARY",
  },
  GBP: {
    iso_name: "GBP",
    full_name: "British Pound Sterling",
    type: "PRIMARY",
  },
  HKD: {
    iso_name: "HKD",
    full_name: "Hong Kong Dollar",
    type: "SECONDARY",
  },
  HRK: {
    iso_name: "HRK",
    full_name: "Croatian Kuna",
    type: "SECONDARY",
  },
  HUF: {
    iso_name: "HUF",
    full_name: "Hungarian Forint",
    type: "SECONDARY",
  },
  IDR: {
    iso_name: "IDR",
    full_name: "Indonesian Rupiah",
    type: "TERTIARY",
  },
  ILS: {
    iso_name: "ILS",
    full_name: "Israeli New Sheqel",
    type: "SECONDARY",
  },
  INR: {
    iso_name: "INR",
    full_name: "Indian Rupee",
    type: "TERTIARY",
  },
  JPY: {
    iso_name: "JPY",
    full_name: "Japanese Yen",
    type: "SECONDARY",
  },
  KES: {
    iso_name: "KES",
    full_name: "Kenyan Shilling",
    type: "SECONDARY",
  },
  KRW: { iso_name: "KRW", full_name: "Korean Won", type: "SECONDARY" },

  KWD: {
    iso_name: "KWD",
    full_name: "Kuwaiti Dinar",
    type: "SECONDARY",
  },
  MYR: {
    iso_name: "MYR",
    full_name: "Malaysian Ringgit",
    type: "TERTIARY",
  },
  NOK: {
    iso_name: "NOK",
    full_name: "Norwegian Krone",
    type: "SECONDARY",
  },
  NZD: {
    iso_name: "NZD",
    full_name: "New Zealand Dollar",
    type: "SECONDARY",
  },
  OMR: {
    iso_name: "OMR",
    full_name: "Omani Rial",
    type: "SECONDARY",
  },
  PHP: {
    iso_name: "PHP",
    full_name: "Philippine Peso",
    type: "TERTIARY",
  },
  PLN: {
    iso_name: "PLN",
    full_name: "Polish Zloty",
    type: "SECONDARY",
  },
  QAR: {
    iso_name: "QAR",
    full_name: "Qatari Rial",
    type: "SECONDARY",
  },
  RON: {
    iso_name: "RON",
    full_name: "Romanian Leu",
    type: "SECONDARY",
  },
  SAR: {
    iso_name: "SAR",
    full_name: "Saudi Riyal",
    type: "SECONDARY",
  },
  SEK: {
    iso_name: "SEK",
    full_name: "Swedish Krona",
    type: "SECONDARY",
  },
  SGD: {
    iso_name: "SGD",
    full_name: "Singapore Dollar",
    type: "SECONDARY",
  },
  THB: {
    iso_name: "THB",
    full_name: "Thai Baht",
    type: "SECONDARY",
  },
  TRY: {
    iso_name: "TRY",
    full_name: "Turkish Lira",
    type: "SECONDARY",
  },
  UGX: {
    iso_name: "UGX",
    full_name: "Ugandan Shilling",
    type: "SECONDARY",
  },
  USD: {
    iso_name: "USD",
    full_name: "United States Dollar",
    type: "PRIMARY",
  },
  ZAR: {
    iso_name: "ZAR",
    full_name: "South African Rand",
    type: "SECONDARY",
  },
};

export const currency_code_to_symbol = {
  AED: "AED",
  AFN: "L",
  ALL: "؋",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "A$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "B",
  BOB: "Bs",
  BRL: "R",
  BSD: "B",
  BTN: "Nu",
  BWP: "P",
  BYN: "Br",
  BZD: "BZ",
  CAD: "CA",
  CDF: "FC",
  CHF: "CHF",
  CLP: "$",
  CNH: "¥",
  CNY: "¥",
  COP: "$",
  CRC: "₡",
  CUP: "CUC",
  CVE: "CVE",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD",
  DZD: "دج",
  EGP: "E£",
  ERN: "Nkf",
  ETB: "Br",
  EUR: "€",
  FKP: "FK£",
  GBP: "£",
  GEL: "₾",
  GHS: "GH₵",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "G",
  HKD: "HK",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "ft",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "Íkr",
  JMD: "J",
  JOD: "ينار",
  JPY: "¥",
  KES: "KSh",
  KGS: "som",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "ك",
  KYD: "CI",
  KZT: "₸",
  LAK: "₭",
  LBP: "ل.ل",
  LKR: "Rs",
  LRD: "LD",
  LSL: "L",
  LYD: "LD",
  MAD: "DH",
  MDL: "L",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP",
  MRU: "UM",
  MUR: "₨",
  MVR: "MRf",
  MWK: "K",
  MXN: "$",
  MYR: "RM",
  MZN: "MT",
  NAD: "N",
  NGN: "₦",
  NIO: "C",
  NOK: "kr",
  NPR: "Rs",
  NZD: "NZ$",
  OMR: "ر.ع",
  PAB: "B/.",
  PEN: "S/.",
  PHP: "₱",
  PKR: "Rs",
  PLN: "zł",
  PYG: "₲",
  QAR: "ر.ق",
  RON: "lei",
  RSD: "RSD",
  RUB: "₽",
  RWF: "R₣",
  SAR: "SR",
  SCR: "SR",
  SDG: "SDG",
  SEK: "kr",
  SGD: "S$",
  SLL: "Le",
  SOS: "Sh.So",
  SRD: "Sr",
  SSP: "SS£",
  STN: "Db",
  SYP: "£S",
  SZL: "L",
  THB: "฿",
  TJS: "TJS",
  TMT: "m",
  TND: "د.ت",
  TRY: "₺",
  TTD: "TT",
  TWD: "NT",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYU: "$U",
  UZS: "som",
  VED: "Bs",
  VND: "₫",
  XAF: "FCFA",
  XCD: "$",
  XOF: "CFA",
  YER: "﷼",
  ZAR: "R",
};

export const PLAN_SCOPE_LIST = [
  {
    key: "DOMESTIC",
    value: "DOMESTIC",
  },
  {
    key: "GCA",
    value: "GCA",
  },
  {
    key: "STABLE",
    value: "STABLE",
  },
];

export const CONTRACTING_ENTITY = ["AU", "SG"];
export const ACCOUNT_TYPE = ["CMA"];

export const CONTRACTING_ENTITY_COUNTRY = [
  {
    value: "AU",
    key: "Australia",
  },
  {
    value: "SG",
    key: "Singapore",
  },
  {
    value: "HK",
    key: "Hong Kong",
  },
  {
    value: "NZ",
    key: "New Zealand",
  },
  {
    value: "US",
    key: "United States",
  },
  {
    value: "CA",
    key: "Canada",
  },
  {
    value: "UK",
    key: "United Kingdom",
  },
];

export const decimal_format_list = {
  2: "0,0.00",
  3: "0,0.000",
  0: "0,0",
};

export const sanctioned_countries = [
  "AF",
  "AL",
  "AZ",
  "BY",
  "BA",
  "BI",
  "CF",
  "CG",
  "HR",
  "CU",
  "ER",
  "ET",
  "PS",
  "GW",
  "HT",
  "IR",
  "IQ",
  "XK",
  "LB",
  "LY",
  "MK",
  "MM",
  "NI",
  "KP",
  "RU",
  "SO",
  "SS",
  "SD",
  "SY",
  "TN",
  "VE",
  "YE",
  "ZW",
  "CD",
  "EH",
  "LR",
];

export const nationality_list = [
  { name: "Andorran", code: "AD" },
  { name: "Emirati", code: "AE" },
  { name: "Antiguan, Barbudan", code: "AG" },
  { name: "Anguillian", code: "AI" },
  // { name: "Albanian", code: "AL" },
  { name: "Armenian", code: "AM" },
  { name: "Dutch", code: "AN" },
  { name: "Angolan", code: "AO" },
  { name: "Argentinean", code: "AR" },
  { name: "American Samoan", code: "AS" },
  { name: "Austrian", code: "AT" },
  { name: "Australian", code: "AU" },
  { name: "Aruban", code: "AW" },
  { name: "Swedish", code: "AX" },
  // { name: "Azerbaijani", code: "AZ" },
  // { name: "Bosnian, Herzegovinian", code: "BA" },
  { name: "Barbadian", code: "BB" },
  { name: "Bangladeshi", code: "BD" },
  { name: "Belgian", code: "BE" },
  { name: "Burkinabe", code: "BF" },
  { name: "Bulgarian", code: "BG" },
  { name: "Bahraini", code: "BH" },
  { name: "Beninese", code: "BJ" },
  { name: "Saint Barthélemy Islander", code: "BL" },
  { name: "Bermudian", code: "BM" },
  { name: "Bruneian", code: "BN" },
  { name: "Bolivian", code: "BO" },
  { name: "Dutch (BQ)", code: "BQ" },
  { name: "Brazilian", code: "BR" },
  { name: "Bahamian", code: "BS" },
  { name: "Bhutanese", code: "BT" },
  { name: "Motswana", code: "BW" },
  { name: "Belizean", code: "BZ" },
  { name: "Canadian", code: "CA" },
  { name: "Cocos Islander", code: "CC" },
  { name: "Swiss", code: "CH" },
  { name: "Ivorian", code: "CI" },
  { name: "Cook Islander", code: "CK" },
  { name: "Chilean", code: "CL" },
  { name: "Cameroonian", code: "CM" },
  { name: "Chinese", code: "CN" },
  { name: "Colombian", code: "CO" },
  { name: "Costa Rican", code: "CR" },
  { name: "Montenegrins, Serbs", code: "CS" },
  { name: "Cape Verdian", code: "CV" },
  { name: "Curaçaoan", code: "CW" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cypriot", code: "CY" },
  { name: "Czech", code: "CZ" },
  { name: "German", code: "DE" },
  { name: "Djibouti", code: "DJ" },
  { name: "Danish", code: "DK" },
  { name: "Dominican", code: "DM" },
  { name: "Dominican (DO)", code: "DO" },
  { name: "Algerian", code: "DZ" },
  { name: "Ecuadorean", code: "EC" },
  { name: "Estonian", code: "EE" },
  { name: "Egyptian", code: "EG" },
  // { name: "Eritrean", code: "ER" },
  { name: "Spanish", code: "ES" },
  // { name: "Ethiopian", code: "ET" },
  { name: "Finnish", code: "FI" },
  { name: "Fijian", code: "FJ" },
  { name: "Falkland Islander", code: "FK" },
  { name: "Micronesian", code: "FM" },
  { name: "Faroese", code: "FO" },
  { name: "French", code: "FR" },
  { name: "Gabonese", code: "GA" },
  { name: "British", code: "GB" },
  { name: "Grenadian", code: "GD" },
  { name: "Georgian", code: "GE" },
  { name: "Channel Islander", code: "GG" },
  { name: "Ghanaian", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greenlandic", code: "GL" },
  { name: "Gambian", code: "GM" },
  { name: "Guinean", code: "GN" },
  { name: "Guadeloupian", code: "GP" },
  { name: "Equatorial Guinean", code: "GQ" },
  { name: "Greek", code: "GR" },
  { name: "South Georgia and the South Sandwich Islander", code: "GS" },
  { name: "Guatemalan", code: "GT" },
  { name: "Guamanian", code: "GU" },
  // { name: "Guinea-Bissauan", code: "GW" },
  { name: "Guyanese", code: "GY" },
  { name: "Chinese (HK)", code: "HK" },
  { name: "Heard and McDonald Islander", code: "HM" },
  { name: "Honduran", code: "HN" },
  // { name: "Croatian", code: "HR" },
  // { name: "Haitian", code: "HT" },
  { name: "Hungarian", code: "HU" },
  { name: "Indonesian", code: "ID" },
  { name: "Irish", code: "IE" },
  { name: "Israeli", code: "IL" },
  { name: "Manx", code: "IM" },
  { name: "Indian (IN)", code: "IN" },
  { name: "Indian (IO)", code: "IO" },
  { name: "Icelander", code: "IS" },
  { name: "Italian", code: "IT" },
  { name: "Channel Islander (JE)", code: "JE" },
  { name: "Jamaican", code: "JM" },
  { name: "Jordanian", code: "JO" },
  { name: "Japanese", code: "JP" },
  { name: "Kenyan", code: "KE" },
  { name: "Kirghiz", code: "KG" },
  { name: "Cambodian", code: "KH" },
  { name: "I-Kiribati", code: "KI" },
  { name: "Comoran", code: "KM" },
  { name: "Kittian and Nevisian", code: "KN" },
  { name: "South Korean", code: "KR" },
  { name: "Kuwaiti", code: "KW" },
  { name: "Caymanian", code: "KY" },
  { name: "Kazakhstani", code: "KZ" },
  { name: "Laotian", code: "LA" },
  { name: "Saint Lucian", code: "LC" },
  { name: "Liechtensteiner", code: "LI" },
  { name: "Sri Lankan", code: "LK" },
  { name: "Mosotho", code: "LS" },
  { name: "Lithuanian", code: "LT" },
  { name: "Luxembourger", code: "LU" },
  { name: "Latvian", code: "LV" },
  { name: "Moroccan", code: "MA" },
  { name: "Monegasque", code: "MC" },
  { name: "Moldovan", code: "MD" },
  { name: "Montenegrin", code: "ME" },
  { name: "Saint Martin Islander", code: "MF" },
  { name: "Malagasy", code: "MG" },
  { name: "Marshallese", code: "MH" },
  // { name: "Macedonian", code: "MK" },
  { name: "Malian", code: "ML" },
  // { name: "Myanmar", code: "MM" },
  { name: "Mongolian", code: "MN" },
  { name: "Chinese (MO)", code: "MO" },
  { name: "American", code: "MP" },
  { name: "French(MQ)", code: "MQ" },
  { name: "Mauritanian", code: "MR" },
  { name: "Montserratian", code: "MS" },
  { name: "Maltese", code: "MT" },
  { name: "Mauritian", code: "MU" },
  { name: "Maldivan", code: "MV" },
  { name: "Malawian", code: "MW" },
  { name: "Mexican", code: "MX" },
  { name: "Malaysian", code: "MY" },
  { name: "Mozambican", code: "MZ" },
  { name: "Namibian", code: "NA" },
  { name: "New Caledonian", code: "NC" },
  { name: "Nigerian", code: "NE" },
  { name: "Norfolk Islander", code: "NF" },
  { name: "Nigerian (NG)", code: "NG" },
  // { name: "Nicaraguan", code: "NI" },
  { name: "Dutch (NL)", code: "NL" },
  { name: "Norwegian", code: "NO" },
  { name: "Nepalese", code: "NP" },
  { name: "Nauruan", code: "NR" },
  { name: "Niuean", code: "NU" },
  { name: "New Zealander", code: "NZ" },
  { name: "Omani", code: "OM" },
  { name: "Panamanian", code: "PA" },
  { name: "Peruvian", code: "PE" },
  { name: "French Polynesian", code: "PF" },
  { name: "Papua New Guinean", code: "PG" },
  { name: "Filipino", code: "PH" },
  { name: "Pakistani", code: "PK" },
  { name: "Polish", code: "PL" },
  { name: "French (PM)", code: "PM" },
  { name: "Pitcairn Islander", code: "PN" },
  { name: "Puerto Rican", code: "PR" },
  // { name: "Palestinian", code: "PS" },
  { name: "Portuguese", code: "PT" },
  { name: "Palauan", code: "PW" },
  { name: "Paraguayan", code: "PY" },
  { name: "Qatari", code: "QA" },
  { name: "French (RE)", code: "RE" },
  { name: "Romanian", code: "RO" },
  // { name: "Russian", code: "RU" },
  { name: "Rwandan", code: "RW" },
  { name: "Saudi Arabian", code: "SA" },
  { name: "Solomon Islander", code: "SB" },
  { name: "Seychellois", code: "SC" },
  { name: "Swedish (SE)", code: "SE" },
  { name: "Singaporean", code: "SG" },
  { name: "Saint Helenian", code: "SH" },
  { name: "Slovene", code: "SI" },
  { name: "Norwegian (SJ)", code: "SJ" },
  { name: "Slovak", code: "SK" },
  { name: "Sierra Leonean", code: "SL" },
  { name: "Sammarinese", code: "SM" },
  { name: "Senegalese", code: "SN" },
  { name: "Serbian", code: "RS" },
  { name: "Surinamer", code: "SR" },
  { name: "Sao Tomean", code: "ST" },
  { name: "Salvadoran", code: "SV" },
  { name: "Swazi", code: "SZ" },
  { name: "Turks and Caicos Islander", code: "TC" },
  { name: "Chadian", code: "TD" },
  { name: "French (TF)", code: "TF" },
  { name: "Togolese", code: "TG" },
  { name: "Thai", code: "TH" },
  { name: "Tadzhik", code: "TJ" },
  { name: "Tokelauan", code: "TK" },
  { name: "East Timorese", code: "TL" },
  { name: "Turkmen", code: "TM" },
  // { name: "Tunisian", code: "TN" },
  { name: "Tongan", code: "TO" },
  { name: "Turkish", code: "TR" },
  { name: "Trinidadian", code: "TT" },
  { name: "Tuvaluan", code: "TV" },
  { name: "Taiwanese", code: "TW" },
  { name: "Tanzanian", code: "TZ" },
  { name: "Ukrainian", code: "UA" },
  { name: "Ugandan", code: "UG" },
  { name: "American (UM)", code: "UM" },
  { name: "American (US)", code: "US" },
  { name: "Uruguayan", code: "UY" },
  { name: "Uzbekistani", code: "UZ" },
  { name: "Italian(VA)", code: "VA" },
  { name: "Saint Vincentian", code: "VC" },
  { name: "Virgin Islander (VG)", code: "VG" },
  { name: "Virgin Islander (VI)", code: "VI" },
  { name: "Vietnamese", code: "VN" },
  { name: "Ni-Vanuatu", code: "VU" },
  { name: "Wallis and Futuna Islander", code: "WF" },
  { name: "Samoan", code: "WS" },
  { name: "French(YT)", code: "YT" },
  { name: "South African", code: "ZA" },
  { name: "Zambian", code: "ZM" },
];

export const identity_document_type_list = [
  {
    value: "WORK_PERMIT",
    label: "WORK PERMIT",
  },
  {
    value: "PASSPORT",
    label: "PASSPORT",
  },
  {
    value: "NATIONAL_ID",
    label: "NATIONAL ID",
  },
  {
    value: "DRIVERS_LICENCE",
    label: "DRIVERS LICENCE",
  },
  {
    value: "OTHERS",
    label: "OTHERS",
  },
];

export const COUNTRY_CODES = [
  { name: "Afghanistan", dial_code: "+93", code: "AF" },
  { name: "Albania", dial_code: "+355", code: "AL" },
  { name: "Algeria", dial_code: "+213", code: "DZ" },
  { name: "American Samoa", dial_code: "+1684", code: "AS" },
  { name: "Andorra", dial_code: "+376", code: "AD" },
  { name: "Angola", dial_code: "+244", code: "AO" },
  { name: "Anguilla", dial_code: "+1264", code: "AI" },
  { name: "Antarctica", dial_code: "+672", code: "AQ" },
  { name: "Antigua and Barbuda", dial_code: "+1268", code: "AG" },
  { name: "Argentina", dial_code: "+54", code: "AR" },
  { name: "Armenia", dial_code: "+374", code: "AM" },
  { name: "Aruba", dial_code: "+297", code: "AW" },
  { name: "Australia", dial_code: "+61", code: "AU" },
  { name: "Austria", dial_code: "+43", code: "AT" },
  { name: "Bahamas", dial_code: "+1242", code: "BS" },
  { name: "Bahrain", dial_code: "+973", code: "BH" },
  { name: "Bangladesh", dial_code: "+880", code: "BD" },
  { name: "Barbados", dial_code: "+1246", code: "BB" },
  { name: "Belgium", dial_code: "+32", code: "BE" },
  { name: "Belize", dial_code: "+501", code: "BZ" },
  { name: "Benin", dial_code: "+229", code: "BJ" },
  { name: "Bermuda", dial_code: "+1441", code: "BM" },
  { name: "Bhutan", dial_code: "+975", code: "BT" },
  { name: "Bolivia", dial_code: "+591", code: "BO" },
  { name: "Botswana", dial_code: "+267", code: "BW" },
  { name: "Brazil", dial_code: "+55", code: "BR" },
  { name: "British Indian Ocean Territory", dial_code: "+246", code: "IO" },
  { name: "Brunei Darussalam", dial_code: "+673", code: "BN" },
  { name: "Bulgaria", dial_code: "+359", code: "BG" },
  { name: "Burkina Faso", dial_code: "+226", code: "BF" },
  { name: "Cambodia", dial_code: "+855", code: "KH" },
  { name: "Cameroon", dial_code: "+237", code: "CM" },
  { name: "Canada", dial_code: "+1", code: "CA" },
  { name: "Cape Verde", dial_code: "+238", code: "CV" },
  { name: "Cayman Islands", dial_code: "+1345", code: "KY" },
  { name: "Chad", dial_code: "+235", code: "TD" },
  { name: "Chile", dial_code: "+56", code: "CL" },
  { name: "China", dial_code: "+86", code: "CN" },
  { name: "Christmas Island", dial_code: "+61", code: "CX" },
  { name: "Cocos (Keeling) Islands", dial_code: "+61", code: "CC" },
  { name: "Colombia", dial_code: "+57", code: "CO" },
  { name: "Comoros", dial_code: "+269", code: "KM" },
  { name: "Cook Islands", dial_code: "+682", code: "CK" },
  { name: "Costa Rica", dial_code: "+506", code: "CR" },
  { name: "Côte d'Ivoire", dial_code: "+225", code: "CI" },
  { name: "Cyprus", dial_code: "+357", code: "CY" },
  { name: "Czech Republic", dial_code: "+420", code: "CZ" },
  { name: "Denmark", dial_code: "+45", code: "DK" },
  { name: "Djibouti", dial_code: "+253", code: "DJ" },
  { name: "Dominica", dial_code: "+1767", code: "DM" },
  { name: "Dominican Republic", dial_code: "+1849", code: "DO" },
  { name: "Ecuador", dial_code: "+593", code: "EC" },
  { name: "Egypt", dial_code: "+20", code: "EG" },
  { name: "El Salvador", dial_code: "+503", code: "SV" },
  { name: "Estonia", dial_code: "+372", code: "EE" },
  { name: "Fiji", dial_code: "+679", code: "FJ" },
  { name: "Finland", dial_code: "+358", code: "FI" },
  { name: "France", dial_code: "+33", code: "FR" },
  { name: "Gabon", dial_code: "+241", code: "GA" },
  { name: "Gambia", dial_code: "+220", code: "GM" },
  { name: "Georgia", dial_code: "+995", code: "GE" },
  { name: "Germany", dial_code: "+49", code: "DE" },
  { name: "Ghana", dial_code: "+233", code: "GH" },
  { name: "Gibraltar", dial_code: "+350", code: "GI" },
  { name: "Greece", dial_code: "+30", code: "GR" },
  { name: "Greenland", dial_code: "+299", code: "GL" },
  { name: "Grenada", dial_code: "+1473", code: "GD" },
  { name: "Guadeloupe", dial_code: "+590", code: "GP" },
  { name: "Guam", dial_code: "+1671", code: "GU" },
  { name: "Guatemala", dial_code: "+502", code: "GT" },
  { name: "Guernsey", dial_code: "+44", code: "GG" },
  { name: "Guinea", dial_code: "+224", code: "GN" },
  { name: "Guyana", dial_code: "+592", code: "GY" },
  { name: "Honduras", dial_code: "+504", code: "HN" },
  { name: "Hong Kong", dial_code: "+852", code: "HK" },
  { name: "Hungary", dial_code: "+36", code: "HU" },
  { name: "Iceland", dial_code: "+354", code: "IS" },
  { name: "India", dial_code: "+91", code: "IN" },
  { name: "Indonesia", dial_code: "+62", code: "ID" },
  { name: "Ireland", dial_code: "+353", code: "IE" },
  { name: "Israel", dial_code: "+972", code: "IL" },
  { name: "Italy", dial_code: "+39", code: "IT" },
  { name: "Jamaica", dial_code: "+1876", code: "JM" },
  { name: "Japan", dial_code: "+81", code: "JP" },
  { name: "Jersey", dial_code: "+44", code: "JE" },
  { name: "Jordan", dial_code: "+962", code: "JO" },
  { name: "Kazakhstan", dial_code: "+7", code: "KZ" },
  { name: "Kenya", dial_code: "+254", code: "KE" },
  { name: "Kuwait", dial_code: "+965", code: "KW" },
  { name: "Kyrgyzstan", dial_code: "+996", code: "KG" },
  { name: "Latvia", dial_code: "+371", code: "LV" },
  { name: "Lebanon", dial_code: "+961", code: "LB" },
  { name: "Lesotho", dial_code: "+266", code: "LS" },
  { name: "Lithuania", dial_code: "+370", code: "LT" },
  { name: "Luxembourg", dial_code: "+352", code: "LU" },
  { name: "Macau", dial_code: "+853", code: "MO" },
  { name: "Madagascar", dial_code: "+261", code: "MG" },
  { name: "Malawi", dial_code: "+265", code: "MW" },
  { name: "Malaysia", dial_code: "+60", code: "MY" },
  { name: "Maldives", dial_code: "+960", code: "MV" },
  { name: "Mali", dial_code: "+223", code: "ML" },
  { name: "Malta", dial_code: "+356", code: "MT" },
  { name: "Marshall Islands", dial_code: "+692", code: "MH" },
  { name: "Martinique", dial_code: "+596", code: "MQ" },
  { name: "Mauritania", dial_code: "+222", code: "MR" },
  { name: "Mauritius", dial_code: "+230", code: "MU" },
  { name: "Mayotte", dial_code: "+262", code: "YT" },
  { name: "Mexico", dial_code: "+52", code: "MX" },
  { name: "Micronesia", dial_code: "+691", code: "FM" },
  { name: "Moldova", dial_code: "+373", code: "MD" },
  { name: "Monaco", dial_code: "+377", code: "MC" },
  { name: "Mongolia", dial_code: "+976", code: "MN" },
  { name: "Montenegro", dial_code: "+382", code: "ME" },
  { name: "Montserrat", dial_code: "+1664", code: "MS" },
  { name: "Morocco", dial_code: "+212", code: "MA" },
  { name: "Mozambique", dial_code: "+258", code: "MZ" },
  { name: "Namibia", dial_code: "+264", code: "NA" },
  { name: "Nauru", dial_code: "+674", code: "NR" },
  { name: "Nepal", dial_code: "+977", code: "NP" },
  { name: "Netherlands", dial_code: "+31", code: "NL" },
  { name: "New Caledonia", dial_code: "+687", code: "NC" },
  { name: "New Zealand", dial_code: "+64", code: "NZ" },
  { name: "Nicaragua", dial_code: "+505", code: "NI" },
  { name: "Niger", dial_code: "+227", code: "NE" },
  { name: "Nigeria", dial_code: "+234", code: "NG" },
  { name: "Niue", dial_code: "+683", code: "NU" },
  { name: "Norfolk Island", dial_code: "+672", code: "NF" },
  { name: "North Macedonia", dial_code: "+389", code: "MK" },
  { name: "Northern Mariana Islands", dial_code: "+1670", code: "MP" },
  { name: "Norway", dial_code: "+47", code: "NO" },
  { name: "Oman", dial_code: "+968", code: "OM" },
  { name: "Pakistan", dial_code: "+92", code: "PK" },
  { name: "Palau", dial_code: "+680", code: "PW" },
  { name: "Palestine", dial_code: "+970", code: "PS" },
  { name: "Panama", dial_code: "+507", code: "PA" },
  { name: "Papua New Guinea", dial_code: "+675", code: "PG" },
  { name: "Paraguay", dial_code: "+595", code: "PY" },
  { name: "Peru", dial_code: "+51", code: "PE" },
  { name: "Philippines", dial_code: "+63", code: "PH" },
  { name: "Poland", dial_code: "+48", code: "PL" },
  { name: "Portugal", dial_code: "+351", code: "PT" },
  { name: "Puerto Rico", dial_code: "+1787", code: "PR" },
  { name: "Qatar", dial_code: "+974", code: "QA" },
  { name: "Romania", dial_code: "+40", code: "RO" },
  { name: "Rwanda", dial_code: "+250", code: "RW" },
  { name: "Saint Kitts and Nevis", dial_code: "+1869", code: "KN" },
  { name: "Saint Lucia", dial_code: "+1758", code: "LC" },
  { name: "Saint Pierre and Miquelon", dial_code: "+508", code: "PM" },
  { name: "Saint Vincent and the Grenadines", dial_code: "+1784", code: "VC" },
  { name: "Samoa", dial_code: "+685", code: "WS" },
  { name: "San Marino", dial_code: "+378", code: "SM" },
  { name: "Saudi Arabia", dial_code: "+966", code: "SA" },
  { name: "Senegal", dial_code: "+221", code: "SN" },
  { name: "Serbia", dial_code: "+381", code: "RS" },
  { name: "Seychelles", dial_code: "+248", code: "SC" },
  { name: "Sierra Leone", dial_code: "+232", code: "SL" },
  { name: "Singapore", dial_code: "+65", code: "SG" },
  { name: "Slovakia", dial_code: "+421", code: "SK" },
  { name: "Slovenia", dial_code: "+386", code: "SI" },
  { name: "Solomon Islands", dial_code: "+677", code: "SB" },
  { name: "South Africa", dial_code: "+27", code: "ZA" },
  { name: "South Korea", dial_code: "+82", code: "KR" },
  { name: "Spain", dial_code: "+34", code: "ES" },
  { name: "Sri Lanka", dial_code: "+94", code: "LK" },
  { name: "Suriname", dial_code: "+597", code: "SR" },
  { name: "Swaziland", dial_code: "+268", code: "SZ" },
  { name: "Sweden", dial_code: "+46", code: "SE" },
  { name: "Switzerland", dial_code: "+41", code: "CH" },
  { name: "Taiwan", dial_code: "+886", code: "TW" },
  { name: "Tajikistan", dial_code: "+992", code: "TJ" },
  { name: "Tanzania", dial_code: "+255", code: "TZ" },
  { name: "Thailand", dial_code: "+66", code: "TH" },
  { name: "Togo", dial_code: "+228", code: "TG" },
  { name: "Tonga", dial_code: "+676", code: "TO" },
  { name: "Trinidad and Tobago", dial_code: "+1868", code: "TT" },
  { name: "Tunisia", dial_code: "+216", code: "TN" },
  { name: "Turkey", dial_code: "+90", code: "TR" },
  { name: "Turkmenistan", dial_code: "+993", code: "TM" },
  { name: "Turks and Caicos Islands", dial_code: "+1649", code: "TC" },
  { name: "Tuvalu", dial_code: "+688", code: "TV" },
  { name: "Uganda", dial_code: "+256", code: "UG" },
  { name: "Ukraine", dial_code: "+380", code: "UA" },
  { name: "United Arab Emirates", dial_code: "+971", code: "AE" },
  { name: "United Kingdom", dial_code: "+44", code: "GB" },
  { name: "United States", dial_code: "+1", code: "US" },
  { name: "Uruguay", dial_code: "+598", code: "UY" },
  { name: "Uzbekistan", dial_code: "+998", code: "UZ" },
  { name: "Vanuatu", dial_code: "+678", code: "VU" },
  { name: "Venezuela", dial_code: "+58", code: "VE" },
  { name: "Vietnam", dial_code: "+84", code: "VN" },
  { name: "Virgin Islands, British", dial_code: "+1284", code: "VG" },
  { name: "Virgin Islands, U.S.", dial_code: "+1340", code: "VI" },
  { name: "Wallis and Futuna", dial_code: "+681", code: "WF" },
  { name: "Zambia", dial_code: "+260", code: "ZM" },
  { name: "Zimbabwe", dial_code: "+263", code: "ZW" },
];

export const available_accounting_platforms = [
  {
    label: "Xero",
    value: "xero",
  },
  {
    label: "Quickbooks",
    value: "quickbooks",
  },
];

export const FX_HEDGING_CONNECTOR_PLATFORM_LIST = [
  {
    label: "Currency Cloud",
    value: "currency_cloud",
  },
  {
    label: "Velocity Trade",
    value: "velocity_trade",
  },
];

export const UUIDv4_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
